import { extendTheme } from "@chakra-ui/react";

const customTheme = extendTheme({
    fonts: {
        heading: `'pixelify'` ,
        body: `pixelify`,
    },
})
export default customTheme;
